<template lang="html" id="breadcrumb">
    <span >
        <!-- Figure this out -->
      <router-link v-if="!route.meta.bcDynamic" :to="{name: route.name}">
        {{route.meta.bcLinkText}}
      </router-link>
      <!-- Figure this out -->
      <router-link v-if="route.meta.bcDynamic" :to= "{name: route.name, params: {id: $route.params.id}}">
    <!-- Figure this out -->

        <template v-if="value">
          {{formattedValue}}
        </template>
        <!-- Shows during load -->
        <template v-if="!value">
          {{loadingText}}
        </template>
      </router-link>
    </span>
</template>

<script>
export default {
    props: ['route'],
    beforeCreate() {
        this.$options.computed.value = function() {
            if (this.route.meta.bcGetter) {
                return this.$store.getters[this.route.meta.bcGetter]
            } else {
                return null
            }
        }
    },
    computed: {
        formattedValue() {
            return this.route.meta.bcLinkText(this.value)
        },
        loadingText() {
            const loadingText = this.route.meta.bcLoadingText
            return loadingText ? loadingText : 'Loading...'
        }
    }
}
</script>

<style lang="css">
</style>
